<template>
    <div class="entity-goods-item" @click="handleClick(data)">
        <img class="entity-goods-img" v-lazy="$publicFn.optimizationImage(data.picUrl || data.pic, imgPrams)">
        <div class="entity-goods-info">
            <div>
                <div class="entity-goods-title van-ellipsis">{{data.name}}</div>
                <div class="entity-goods-tags" v-if="data.categoryName">
                    <div class="tags-item" v-for="(tag,index) in data.categoryName.split(',')" :key="index">{{tag}}</div>
                </div>
                <div class="entity-goods-tags" v-if="data.labels && data.labels.length">
                    <div class="tags-item" v-for="(tag,index) in data.labels" :key="index">{{tag}}</div>
                </div>
                </div>
            <div>
                <div class="entity-goods-price">
                    <div class="price-num">
                        
                        <span class="unt" v-if="data.salePrice">¥</span>{{data.salePrice || '免费'}}
                        <div class="sales-num">已售{{formatNum(data.orderNumber)}}</div>    
                    </div>
                </div>
                <!-- <div class="entity-goods-institution" v-if="data.branchName" @click.stop="handleStationPage(data.branchId)">
                    <p class="van-ellipsis">{{data.branchName}}</p>
                    <i class="icon-right" />
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'EntityGoodsItem',
    props: {
        data: {
            type: Object,
            default: ()=>{},
        },
    },
    data() {
        return {
            imgPrams: {
                size: {w:343,h:343}
            }
        }
    },
    methods: {
        formatNum(val) {
            if(val > 10000) {
                return `${parseFloat((val/10000).toFixed(1))}w+笔`
            }
            return `${val || 0}笔`
        },
        handleClick(data) {
            this.$emit('handleClick', data)
        },
        // async handleStationPage(branchId) {
        //     let url = await this.$publicFn.getSaasBranchDomain(branchId);
        //     window.location.href = `${url}/stationPage`
        // }
    },
}
</script>

<style lang="less" scoped>
    .entity-goods-item {
        background-color: #fff;
        border-radius: 16px;
        padding-bottom: 24px;
        width: 343px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        height: 100%;
        border: 1px solid #f1f1f1;
        
        .entity-goods-img {
            width: 100%;
            height: 343px;
            border-radius: 16px 16px 0 0;
            margin-bottom: 16px;
            border-bottom: 1px solid #f1f1f1;
        }
        .entity-goods-info {
            padding: 0 16px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            flex: 1;
        }
        .entity-goods-title {
            font-size: 30px;
            font-weight: 500;
            color: #333333;
            line-height: 38px;
            margin-bottom: 16px;
        }
        .entity-goods-tags {
            display: flex;
            flex-wrap: wrap;
            height: 36px;
            overflow: hidden;
            margin-bottom: 24px;
            .tags-item {
                height: 36px;
                line-height: 36px;
                font-size: 20px;
                color: #999;
                padding: 0 12px;
                margin-right: 8px;
                max-width: 124px;
                background-color: #F2F2F7;
                border-radius: 4px;
            }
        }
        .entity-goods-price {
            display: flex;
            margin-bottom: 16px;
            .price-num {
                font-size: 36px;
                color: #FF2F2F;
                font-weight: 600;
                .unt {
                    font-size: 20px;
                }
                .sales-num {
                    font-size: 20px;
                    color: #999;
                    display: inline-block;
                }
            }
        }
        .entity-goods-institution {
            font-size: 24px;
            color: #999;
            line-height: 28px;
            display: flex;
            align-items: center;
            p {
                max-width: 295px;
            }
            .icon-right {
                width: 16px;
                height: 16px;
                display: inline-block;
                background: url('./assets/images/icon_right.png') no-repeat center center /100% 100%;
            }
        }
    }
</style>